import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { sessionsKeys } from "@/features/sessions/queries/sessionsQueryKeys";
import attendanceService from "@/features/sessions/services/attendanceService";

type Variables = {
    attendanceId: string;
    sessionId: string;
};

export function useClearCheckIn() {
    const queryClient = useQueryClient();

    const mutation = useMutation<void, Error, Variables>({
        mutationFn: async ({ attendanceId }) => {
            await attendanceService.clearCheckIn(attendanceId);
        },
        onError: (error) => {
            const message = error instanceof Error ? error.message : "Failed to check out. Please try again.";
            toast.error(message);
        },
        onSuccess: (_data, variables) => {
            queryClient.invalidateQueries({ queryKey: sessionsKeys.attendance.session(variables.sessionId) });
            queryClient.invalidateQueries({
                queryKey: [...sessionsKeys.attendance.session(variables.sessionId), "status-counts"],
            });
        },
    });

    return {
        error: mutation.error,
        isError: mutation.isError,
        isPending: mutation.isPending,
        mutate: mutation.mutate,
        mutateAsync: mutation.mutateAsync,
        variables: mutation.variables,
    };
}
